//
// Generated class LocalizedEntity
//

/// <reference path="LocalizedEntity_ManagedObject.ts" />

class LocalizedEntity extends LocalizedEntity_ManagedObject
{

}
